<form class="form" [formGroup]="chatbotFormGroup">
	<textarea
		#chatbotInput
		stagesTrim
		rows="1"
		id="chatbot-input"
		type="text"
		class="text fullsize"
		formControlName="chatbot-input"
		[placeholder]="chatbotInputPlaceholder() | translate"
		name="chatbot-input-enabled"
		(change)="onValueChange()"
		(keydown.control.enter)="onCtrlEnter()"
		(keydown.enter)="onEnter($event)"
		stagesAutoGrow
		[minHeight]="42"
		[scrollHeightAddition]="0"
	></textarea>
	@if (disableSendButton) {
		<stages-button
			[buttonType]="'button'"
			[buttonClasses]="'menu-button'"
			[showIconOnly]="true"
			[iconClasses]="'ico-stop-no-circle'"
			[title]="'stop'"
			[loadingSpinConfiguration]="{
				showIconInLoadingSpin: true,
				color: _sendButtonConfiguration.iconStyles.color,
				size: 'sm+',
			}"
			[showLoadingSpin]="disableSendButton"
			(clicked)="onStop()"
		>
		</stages-button>
	}
	@if (!disableSendButton) {
		<stages-button
			[buttonType]="'button'"
			[buttonClasses]="'menu-button'"
			[buttonStyle]="_sendButtonConfiguration.buttonStyles"
			[iconStyle]="_sendButtonConfiguration.iconStyles"
			[showIconOnly]="true"
			[iconClasses]="'ico-message-send'"
			[title]="'send'"
			(clicked)="onEnter()"
		>
		</stages-button>
	}
</form>
<stages-disclaimer-main
	[isChatbot]="true"
	[hideALittle]="true"
	[message]="'ai.general.legal.short'"
></stages-disclaimer-main>
